import { PageContent } from '../../components/modal/styles';
import SocialLogin from '../../components/socialLogin';
import Wallets from '../../components/wallets';

const Connectors = ({ type = 'wallet' }: { type?: string }) => {
  return (
    <PageContent
      style={{
        paddingTop: '30px',
      }}
    >
      {type == 'wallet' ? <Wallets expandList></Wallets> : <SocialLogin expandList />}
    </PageContent>
  );
};

export default Connectors;
